import ENV from "glesys-controlpanel/config/environment";

export function initialize() {
  if (!ENV.googleTagManagerId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });

  let script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${ENV.googleTagManagerId}`;
  document.head.appendChild(script);
}

export default {
  name: "google-tag-manager",
  initialize,
};
